import CONSTANT from "@/services/Constant.js";

export default {
	name: "EventItem",
	props: ['props'],
	computed: {
    },
    created() {
        // console.log('props'+JSON.stringify(props));
    },
	methods: {
        getEventDate(){
            return "25 <br /> DEC";
        },
        /*
        * Method to redirect event details
        */
        goToEventDetails(id) {
            this.$router.push(
                "/events-detail/" + id
            );
        },
	},
	data() {
		return {
            defaultAvatarSrc: CONSTANT.DEFAULTS.defaultAvatarSrc
		}
	}
};